import React from 'react';
import PropTypes from 'prop-types';


import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import axios from '../../config/axiosInstance';

import Input from '../../components/Input/Input';

const styles = theme => ({
  paperWidth: {
    padding: '10px 40px',
    width: '500px',
  },
  day: {
    paddingTop: theme.spacing(4),
    fontWeight: theme.typography.fontWeightStrong,
  },
});

const CalendarDialog = ({
  classes, open, onClose, modalType, holiday, onChange, handleChange, onSubmit,
}) => (
  <div>
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{modalType} feriado</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {holiday.date}

        </DialogContentText>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              name="annual"
              checked={holiday.isAnual}
              onChange={handleChange}
              disabled={modalType === 'Excluir'}
            />
            }
          label="Anual"

        />
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              name="nacional"
              checked={holiday.isNational}
              onChange={handleChange}
              disabled={modalType === 'Excluir' || holiday.location.uf}
            />
            }
          label="Nacional"

        />
        <div style={{ display: 'flex', minWidth: 300, flexDirection: 'column' }}>

          <Input
            elementType="input"
            value={holiday.description}
            onChange={handleChange}
            type="text"
            label="Descrição"
            margin="normal"
            disabled={modalType === 'Excluir'}
            required
          />
          <Input
            elementType="autocomplete"
            label="Local de atuação*"
            name="local"
            value={holiday.location}
            onChange={onChange}
            helperText={' '}
            instruction="Busque por estado ou municipio"
            searchFunction={location => axios.get(`static/locations/keyWords/${location}`)}
            disabled={holiday.isNational || modalType === 'Excluir'}
          />
        </div>

        {
          modalType === 'Excluir' && holiday.isAnual && <div style={{ display: 'flex', flexDirection: 'column' }}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  name="year"
                  checked={holiday.clearYear}
                  onChange={handleChange}
                  disabled={holiday.clearEveryYear}
                />
            }
              label="Excluir este ano"
            />

            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  name="everyYear"
                  checked={holiday.clearEveryYear}
                  onChange={handleChange}
                  disabled={holiday.clearYear}
                />
            }
              label="Excluir este e os seguintes"
            />
          </div>

        }


      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>CANCELAR</Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={(modalType === 'Cadastrar' && holiday.description.trim() === '')
           || (!holiday.location.state && !holiday.isNational)
           || (modalType === 'Excluir' && holiday.isAnual && !holiday.clearYear && !holiday.clearEveryYear)}
          onClick={() => onSubmit(modalType)}
        >
          {modalType}
        </Button>
      </DialogActions>
    </Dialog>
  </div>
);

CalendarDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  modalType: PropTypes.string.isRequired,
  holiday: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default withStyles(styles)(CalendarDialog);
